import PremiumBenefitsCard from "./js/PremiumBenefitsCard";
export default PremiumBenefitsCard;